require('./scss/price-card-placeholder.scss');

export default {
    name: 'PriceCardPlaceholder',

    template: `<div class="price-card price-card-placeholder"></div>`,
};



// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/Components/quotes/PriceCardPlaceholder.js